<template>
    <div class="input__wrapper">
        <div class="text">
            <slot name="text"></slot>
        </div>
        <slot name="input"></slot>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.input__wrapper{
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%;
}
.input__wrapper .text{
/* Caps/C2: 11px Medium */
color: rgb(85, 98, 114);;
font-size: 11px;
font-weight: 500;
line-height: 140%;
letter-spacing: 0%;
text-align: left;
text-transform: uppercase;
}
</style>